import { Stack, Box } from "@mui/material";
import { ChannelCard, VideoCard } from "./";


const Videos = ({ videos, direction, channelDetail }) => {
  if(!videos?.length) return 'Loading...'
  return (
    <Stack direction={ direction || "row" } flexWrap="wrap" justifyContent="center" gap={2}>
      {videos.map((item, idx) => (
        <Box key={idx}>
          {item.id.videoId && <VideoCard video={item} channelDetail={channelDetail} />}
          {item.id.channelId && <ChannelCard channelDetail={item} />}
       </Box>
      ))}
    </Stack>
  )
}

export default Videos
